<template>
  <vue-loading v-if="loading" :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>
  <div v-else id="backup-summary">
    <BackupsNavBar :activeId="id" v-on:csv='downloadCSV' :downloadBtn="true" :text="'Download Summary Report'"/>

    <transition name="fade" mode="in-out"  appear>
      <div class="row">
        <div class="column">
          <div class="card">
            <div class="card-heading">
              Backups By Type
            </div>
            <div class="card-body">
              <div class=row>
                <div class="col-8">
                  <BackupSummaryPie
                    :shelvery="reduceChartData(summary.summary, 'shelvery')"
                    :automated="reduceChartData(summary.summary, 'automated')"
                    :manual="reduceChartData(summary.summary, 'manual')"
                    :awsbackup="reduceChartData(summary.summary, 'awsbackup')"/>
                </div>
                <div class="col">
                  <div class="total-backups">
                    <span class="backup-count">{{ reduceChartData(summary.summary, 'total') }}</span>
                    <span class="backup-count-text">Total Backups</span>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="card">
            <div class="card-heading">
              Total Backups
            </div>
            <div class="card-body">
              <BackupSummaryTotal :totals="formatChartData(summary.summary, 'total')"/>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="card">
            <div class="card-heading">
              Backups By Type and Service
            </div>
            <div class="card-body">
              <BackupSummaryBar
                :shelvery="formatChartData(summary.summary, 'shelvery')"
                :automated="formatChartData(summary.summary, 'automated')"
                :manual="formatChartData(summary.summary, 'manual')"
                :awsbackup="formatChartData(summary.summary, 'awsbackup')"/>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade" mode="in-out" appear>
      <div class="row" key="third-row">
        <div class="column">
          <div class="card">
            <div class="card-heading">
              Resources Managed By Shelvery
            </div>
            <div class="card-body">
              <BackupShelveryManagedChart
                :managed="formatChartData(summary.summary, 'shelvery_managed')"
                :notConfigured="getNotConfigured()"/>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="card">
            <div class="card-heading">
              Orphaned Backups By Type and Service
            </div>
            <div class="card-body">
              <BackupSummaryBar
                :shelvery="formatChartData(summary.orphaned, 'shelvery')"
                :automated="formatChartData(summary.orphaned, 'automated')"
                :manual="formatChartData(summary.orphaned, 'manual')"
                :awsbackup="formatChartData(summary.orphaned, 'awsbackup')"/>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="card">
            <div class="card-heading">
              Backups By Resource Type and AWS Account
            </div>
            <div class="card-body">
              <BackupsByAccount :data="summary.summary"/>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import BackupsNavBar from '@/components/BackupsNavBar'
import BackupSummaryBar from '@/components/charts/BackupSummaryBar'
import BackupSummaryPie from '@/components/charts/BackupSummaryPie'
import BackupSummaryTotal from '@/components/charts/BackupSummaryTotal'
import BackupsByAccount from '@/components/charts/BackupsByAccount'
import BackupShelveryManagedChart from '@/components/charts/BackupShelveryManagedChart'
import VueLoading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'

export default {
  components: {
    VueLoading,
    BackupsNavBar,
    BackupSummaryBar,
    BackupSummaryPie,
    BackupSummaryTotal,
    BackupsByAccount,
    BackupShelveryManagedChart
  },
  name: 'Backups',
  props: [
    'id'
  ],
  computed: {
    ...mapGetters([
      'activeType'
    ])
  },
  data () {
    return {
      loading: false,
      summary: {}
    }
  },
  methods: {
    downloadCSV: function () {
      this.flashMessage.info({
        message: 'Genrating Backups CSV report',
        time: 3000
      })
      HTTP.get(`/backups/summary/${this.activeType}/${this.id}/csv`)
        .then((response) => {
          window.location = response.data.signedUrl
          this.flashMessage.success({
            message: 'Backups CSV report generation complete'
          })
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to generate backups CSV report : ${error.message}`
          })
        })
    },
    getSummary: function () {
      this.loading = true
      this.summary = {}
      HTTP.get(`/backups/summary/${this.activeType}/${this.id}`)
        .then((response) => {
          this.summary = response.data
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to get backups report : ${error.response.data.error}`
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    formatChartData: function (data, type) {
      var dataArray = []
      for (const resource in data) {
        dataArray.push(data[resource][type])
      }
      return dataArray
    },
    reduceChartData: function (data, type) {
      return this.formatChartData(data, type).reduce((a, b) => a + b, 0)
    },
    getNotConfigured: function () {
      var dataArray = []
      for (const resource in this.summary.summary) {
        dataArray.push(this.summary.summary[resource]['resource_count'] - this.summary.summary[resource]['shelvery_managed'])
      }
      return dataArray
    }
  },
  watch: {
    id: function () {
      this.getSummary()
    }
  },
  created: function () {
    this.getSummary()
  }
}
</script>

<style scoped>
.row {
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
}
.column {
  padding-top: 15px;
  flex-direction: column;
  display: flex;
  overflow: hidden;
  flex: 1;
}
.card {
  transition: opacity 200ms;
  background: #ffffff;
  width: auto;
  margin: 5px 15px 10px 15px;
  padding: 15px 15px 15px 15px;
  display: flex;
  border: none;
  border-radius: 0;
  box-sizing: content-box;
  box-shadow: 0 2px 17px -5px rgba(0,0,0,0.2);
}
.total-backups {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.backup-count {
  font-size: 5em;
  font-weight: bold;
  display: block;
}
.backup-count-text {
  font-size: 2em;
  display: block;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 200ms ease-in-out;
}
.fade-enter-to {
  opacity: 1;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.btn-primary, .btn-primary:hover, .btn-primary:active, .btn-primary:visited {
  background-color: #70A1F0 !important;
  border-color: #70A1F0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Backups.vue